module.exports = __webpack_public_path__ + "img/icon-iso.1a6c2e92.png";